import { Check, Loader2 } from 'lucide-react'

interface SavingIndicatorProps {
  isSaving: boolean
}

export function SavingIndicator({ isSaving }: SavingIndicatorProps) {
  if (!isSaving) {
    return (
      <div className="flex items-center gap-1.5 text-xs text-white/40">
        <Check className="w-3 h-3" />
        <span>Layout saved</span>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-1.5 text-xs text-white/60">
      <Loader2 className="w-3 h-3 animate-spin" />
      <span>Saving layout...</span>
    </div>
  )
}
